import ListOfNotNull from 'utils/ListOfNotNull';
import {Speaker, SpeakerNumber} from '@store/call-card/CallCard.types';
import {List, Map} from 'immutable';
import {Seconds} from '@store/@types/util';
import {Call} from '@store/call-card/Call';

export const MiniSpeakerNumber = -1;

export const getSpeakerDescription = (speaker: Speaker, speakerNumber: number) => {
  const name = ListOfNotNull([speaker.firstName, speaker.lastName]).join(' ');
  const role = ListOfNotNull([speaker.title, speaker.company]).join(' ');
  if (name && role) return `${name} - ${role}`;
  if (name) return name;
  if (role) return role;
  return `Speaker ${speakerNumber}`;
};

// Sort speakers by caller first, then talk time from high to low
export function sortCallSpeakers(
  speakers: List<Speaker>,
  call: Call | undefined,
  callTalkTime: Map<SpeakerNumber, Seconds>
) {
  return (
    speakers
      // Talk time high to low
      .sortBy(s => callTalkTime.get(s.speakerNumber))
      .reverse()
      // Always show caller on top
      .sortBy(s => (s.userId === call?.caller.id ? 0 : 1))
      // Update description based on new speaker order
      .map((speaker, index) => ({
        ...speaker,
        description: getSpeakerDescription(speaker, index + 1),
      }))
  );
}
